import { httpCreate } from './http';

const http = httpCreate('/srv/live-watermark-anti-screen');

export const liveWatermarkAntiScreen = {
	getWaterMarkInfo(activityId) {
		return http.get(`/${activityId}`);
	},
	// 直播间水印信息保存
	saveWaterMarkInfo(activityId, data) {
		return http.post(`/${activityId}`, data);
	},
};
